import _ from "lodash";
import { useRef, useState } from "react";

const DEFAULT_OPTIONS = {
  offsetTop: 6,
  tooltipWidth: 288,
  hideDelay: 150,
};

const EDGE_MARGIN = 8;

// tooltipHeight is optional: without it the tooltip always opens below. When
// flipped above, the position uses `bottom` so the real height doesn't matter.
export const getTooltipPosition = ({
  rect,
  offsetTop,
  tooltipWidth,
  tooltipHeight,
  viewportWidth,
  viewportHeight,
}) => {
  const left = _.clamp(
    rect.left + rect.width / 2 - tooltipWidth / 2,
    EDGE_MARGIN,
    Math.max(EDGE_MARGIN, viewportWidth - tooltipWidth - EDGE_MARGIN),
  );
  const spaceBelow = viewportHeight - rect.bottom - offsetTop;
  const spaceAbove = rect.top - offsetTop;
  const shouldOpenAbove =
    tooltipHeight != null &&
    spaceBelow < tooltipHeight &&
    spaceAbove > spaceBelow;

  return shouldOpenAbove
    ? { bottom: viewportHeight - rect.top + offsetTop, left }
    : { top: rect.bottom + offsetTop, left };
};

const useTooltip = (options = {}) => {
  const { offsetTop, tooltipWidth, tooltipHeight, hideDelay } = _.defaults(
    options,
    DEFAULT_OPTIONS,
  );

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState(null);
  const hideTimer = useRef(null);

  const handleMouseEnter = e => {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
      hideTimer.current = null;
    }
    setTooltipPos(
      getTooltipPosition({
        rect: e.currentTarget.getBoundingClientRect(),
        offsetTop,
        tooltipWidth,
        tooltipHeight,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
      }),
    );
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    hideTimer.current = setTimeout(() => {
      setShowTooltip(false);
      setTooltipPos(null);
    }, hideDelay);
  };

  return { showTooltip, tooltipPos, handleMouseEnter, handleMouseLeave };
};

export default useTooltip;
